module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"identifier":"Identifier","registerTree":"Register Tree"},"es":{"identifier":"Identificador","registerTree":"Árbol de registro"},"sw":{"identifier":"Kitambulisho","registerTree":"Sajili Mti"}}')
  delete Component.options._Ctor
}
